// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useContext, useState, useEffect} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import {Button} from '../../../../hola/pub/lib/button';
import {Modal} from '../../../../hola/pub/lib/modal';
import {use_thank_you} from '../toolip/use_thank_you';
import Svg_thank_you from '../../img/dashboard/thank_you.svg';
import {use_qs_with_set} from '../../../../hola/pub/lib/use_qs';
import styles from '../../pages/toolip.io/dashboard.module.less';
// @ts-ignore
import {set, get} from '/util/storage.js';
import {use_app_context} from '../../lib/app_context';
import {Kyc_button} from './kyc/kyc';

const Thank_you = ({on_close})=>{
    const {theme} = useContext(Settings_context);
    const {email, user} = use_thank_you();
    const [pass,] = useState(get('temp_pass'));
    const [zone_type,] = useState(get('thank_you_zone_type'));
    const {kyc} = use_app_context();
    useEffect(()=>{
        set('temp_pass', '');
        set('thank_you_dashboard', '');
        set('thank_you_zone_type', '');
    }, []);
    const show_kyc_block = zone_type == 'events_resi_group' && user
        && kyc.info.status == 'init';
    return <div className={styles.thank_you}>
      <div className={styles.img}><Svg_thank_you/></div>
      <div className={styles.text}>
        <p className={cn(theme.p18, theme.med, theme.color_n700)}>
          Thank you for your purchase!</p>
        <p className={cn(theme.p14, theme.color_n600)}>
          Your invoice has been sent to the email address you've
          provided {'<'}{email}{'>'}</p>
        {pass && !show_kyc_block &&
        <p className={cn(theme.p14, theme.color_n600)}>
          We assigned password for your account <b>{pass}</b><br/>
          You see this password once and should remember it. But you can always
          reset password by clicking "Forget Password".
        </p>}
        {show_kyc_block && <>
          <p className={cn(theme.p16, theme.med, theme.color_n600)}>
          To ensure the security of your account and complete your purchase,
          we need to verify your identity. Please complete the KYC process
          to start using your proxies.
          </p>
          <Kyc_button caption={'Verify now'} cls={styles.thank_you_btn}
            color='black' site='oculus' />
        </>}
        {!show_kyc_block && <Button
          caption={'Got it'} no_jump size={'md'} round={false} fit
          cls={styles.thank_you_btn} on_click={on_close} width={120}/>
        }
      </div>
      <div className={styles.bottom}>
        <p className={theme.p12}>
          Need our help with anything?{' '}
          <a className={cn(styles.link, theme.color_n600)}
            href={'mailto:support@toolip.io'}>Contact support</a>
        </p>
      </div>
    </div>;
};

export const Thank_you_modal = ()=>{
    const {qs, set_qs} = use_qs_with_set();
    const [thank_you_dashboard, set_t] = useState(get('thank_you_dashboard'));
    const close_thank_you = ()=>{
        set_qs({thank_you: undefined, email: undefined});
        set_t(false);
    };
    return <Modal is_open={!!qs.thank_you || !!thank_you_dashboard}
      on_close={close_thank_you} cls={styles.checkout_dialog} paddingless
      low_dim={true} no_logo width={476} on_overlay_click={close_thank_you}
      lighter_close_btn={true}>
      <Thank_you on_close={close_thank_you}/>
    </Modal>;
};
